import { z } from "zod";

export const FormSchema = z.object({
  final_term: z.string().optional(),
});
